<template>
  <v-dialog v-model="$store.state.dialog_line" persistent max-width="290">
    <v-card>
      <v-card-title class="headline">Connect with LINE</v-card-title>
      <v-card-text>Connect with LINE to get Notify</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="closeDialog">Cancel</v-btn>
        <v-btn color="green darken-1" text @click="redirectToLine">Connect</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script lang="ts">

  export default {
    components: {

    },
    methods:{
      redirectToLine () {
        // let line_route = `/line/request-authorize?token=${ this.getToken().access_token }`
        //
        // window.location.href = process.env.NODE_ENV === 'production'
        //   ? line_route
        //   : (
        //     typeof process.env.VUE_APP_BASE_URL !== 'undefined'
        //       ? process.env.VUE_APP_BASE_URL + line_route
        //       : `http://127.0.0.1:8000${ line_route }`
        //   )
      },

      closeDialog () {
        // this.dialog = false

        // this.$store.state.need_register_line = false
      },
    }
  };

</script>
